import React from 'react';
import { Button, Icon, Input, Switch, Tooltip } from 'antd';
import styled from 'styled-components';
import uid from 'uid';
import { isPaymentRequired } from '~/helpers/isPaymentRequired';

var DocCard = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 10px;
  transition: all 0.15s;

  &:hover {
    border-color: #d9d9d9;
  }
`;

var DocHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

var DocNumber = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #595959;
`;

var DocBody = styled.div`
  margin-bottom: 12px;
`;

var DocFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #8c8c8c;
`;

var AddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  color: #8c8c8c;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 4px;

  &:hover {
    border-color: #52c41a;
    color: #52c41a;
    background: #f6ffed;
  }
`;

var EmptyState = styled.div`
  text-align: center;
  padding: 24px 0;
  color: #bfbfbf;
`;

export var DocumentTypesTab = function(props) {
  var types = Array.isArray(props.types) ? props.types : [];
  var setState = props.setState;

  var handleChangeType = function(event, id) {
    var value = event.target.value;
    setState(types.map(function(type) {
      if (type.id !== id) return type;
      return Object.assign({}, type, { description: value });
    }));
  };

  var handleDeleteType = function(id) {
    setState(types.filter(function(type) { return type.id !== id; }));
  };

  var handleTogglePayment = function(id) {
    setState(types.map(function(type) {
      if (type.id !== id) return type;
      var currentValue = isPaymentRequired(type.requires_payment);
      return Object.assign({}, type, { requires_payment: !currentValue });
    }));
  };

  var handleCreateType = function() {
    setState([].concat(types, [{ id: uid(), description: '', requires_payment: true }]));
  };

  if (types.length === 0) {
    return React.createElement('div', null,
      React.createElement(EmptyState, null,
        React.createElement(Icon, { type: 'file-text', style: { fontSize: 32, marginBottom: 8, display: 'block' } }),
        React.createElement('span', { style: { fontSize: 13 } }, 'Nenhum tipo de documento'),
        React.createElement('div', { style: { fontSize: 11, marginTop: 4 } }, 'Defina os tipos de arquivo que o colaborador poderá anexar')
      ),
      React.createElement(AddButton, { onClick: handleCreateType },
        React.createElement(Icon, { type: 'plus' }),
        'Adicionar tipo de documento'
      )
    );
  }

  return React.createElement('div', null,
    types.map(function(type, index) {
      return React.createElement(DocCard, { key: type.id },
        React.createElement(DocHeader, null,
          React.createElement(DocNumber, null,
            React.createElement(Icon, { type: 'file-text', style: { color: '#52c41a' } }),
            'Documento ' + (index + 1)
          ),
          React.createElement(Button, {
            type: 'link',
            size: 'small',
            style: { color: '#ff4d4f', fontSize: 12 },
            onClick: function() { handleDeleteType(type.id); }
          },
            React.createElement(Icon, { type: 'delete' }),
            ' Remover'
          )
        ),
        React.createElement(DocBody, null,
          React.createElement(Input, {
            placeholder: 'Ex: Guia DAS, Nota Fiscal, Comprovante...',
            value: type.description,
            onChange: function(event) { handleChangeType(event, type.id); },
            style: { borderRadius: 6, height: 40, fontSize: 14 }
          })
        ),
        React.createElement(DocFooter, null,
          React.createElement(Switch, {
            size: 'small',
            checked: isPaymentRequired(type.requires_payment),
            onChange: function() { handleTogglePayment(type.id); }
          }),
          React.createElement('span', null, 'Requer pagamento'),
          React.createElement(Tooltip, { title: 'Marque se este documento é uma guia ou boleto que exige pagamento pelo cliente' },
            React.createElement(Icon, { type: 'info-circle', style: { color: '#1890ff', cursor: 'pointer', fontSize: 12 } })
          )
        )
      );
    }),
    React.createElement(AddButton, { onClick: handleCreateType },
      React.createElement(Icon, { type: 'plus' }),
      'Adicionar tipo de documento'
    )
  );
};
